import { SortableTree } from '@/lib/tree/SortableTree';
import SelectMenu from '../Menus/SelectMenu';
import { SidebarEmptyPlaceholder } from './SidebarEmptyPlaceholder';
import { SidebarLibraries } from './SidebarLibraries';
import useSidebarChatbots from './useSidebarChatbots';
import useSortSidebar from './useSortSidebar';

const SidebarChatbots = () => {
  const { sidebarOptions } = useSidebarChatbots('sidebar');

  const { debouncedUpdateSort } = useSortSidebar();

  if (!sidebarOptions) return null;

  return (
    <>
      <SelectMenu />

      <div className="flex flex-col h-full min-h-0 gap-0.5">
        <SidebarLibraries />
        {sidebarOptions.empty && <SidebarEmptyPlaceholder />}
        <SortableTree
          value={sidebarOptions.tree}
          onValueChange={debouncedUpdateSort}
        />
      </div>
    </>
  );
};

export default SidebarChatbots;
